/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetFinanceDashboardParams,
  SuccessResponseDTOFinanceDashboardResponseDTO,
  SuccessResponseDTOListFinanceGatewayDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Get platform financial management dashboard snapshot
 */
export const getFinanceDashboard = (params?: GetFinanceDashboardParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOFinanceDashboardResponseDTO>({
    url: `/admin/api/finance/dashboard`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

/**
 * @summary Probe Stripe / Apple IAP payment gateway configuration readiness
 * Hand-extended for Phase 3 (TM-3263) until orval regen.
 */
export const getFinanceGateways = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListFinanceGatewayDTO>({
    url: `/admin/api/finance/gateways`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetFinanceGatewaysQueryKey = () => {
  return [`/admin/api/finance/gateways`] as const;
};

export function useGetFinanceGateways<
  TData = Awaited<ReturnType<typeof getFinanceGateways>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceGateways>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const { query: queryOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetFinanceGatewaysQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinanceGateways>>> = ({ signal }) =>
    getFinanceGateways(signal);
  const query = useQuery(
    { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<ReturnType<typeof getFinanceGateways>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> },
    queryClient,
  ) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
  query.queryKey = queryKey as DataTag<QueryKey, TData>;
  return query;
}

export const getGetFinanceDashboardQueryKey = (params?: GetFinanceDashboardParams) => {
  return [`/admin/api/finance/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetFinanceDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinanceDashboard>>,
  TError = unknown,
>(
  params?: GetFinanceDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFinanceDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinanceDashboard>>> = ({ signal }) =>
    getFinanceDashboard(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinanceDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFinanceDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinanceDashboard>>
>;
export type GetFinanceDashboardQueryError = unknown;

export function useGetFinanceDashboard<
  TData = Awaited<ReturnType<typeof getFinanceDashboard>>,
  TError = unknown,
>(
  params: undefined | GetFinanceDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinanceDashboard>>,
          TError,
          Awaited<ReturnType<typeof getFinanceDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFinanceDashboard<
  TData = Awaited<ReturnType<typeof getFinanceDashboard>>,
  TError = unknown,
>(
  params?: GetFinanceDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinanceDashboard>>,
          TError,
          Awaited<ReturnType<typeof getFinanceDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFinanceDashboard<
  TData = Awaited<ReturnType<typeof getFinanceDashboard>>,
  TError = unknown,
>(
  params?: GetFinanceDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform financial management dashboard snapshot
 */

export function useGetFinanceDashboard<
  TData = Awaited<ReturnType<typeof getFinanceDashboard>>,
  TError = unknown,
>(
  params?: GetFinanceDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFinanceDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
